import React from "react";
import styled, { css } from "styled-components";

const TAG_TYPE_MAPPING = {
  divida: "danger",
  negociação: "info",
};

const TAG_COLOR_MAPPING = {
  info: "#3454D1",
  warning: "#F1D302",
  danger: "#ED1C24",
};

const TagWrapper = styled.div`
  padding: 0px 5px;
  border-radius: 5px;
  text-align: center;
  text-transform: uppercase;
  margin-block: 0.5rem;

  ${({ type }) => {
    const color = TAG_COLOR_MAPPING[type] || "#7fc008";

    return css`
      border: solid 1px ${color};
      color: ${color};
    `;
  }}

  ${({ onClick }) =>
    !!onClick &&
    css`
      cursor: pointer;
    `}
`;

const Tag = ({ text, ...props }) => (
  <TagWrapper {...props} type={TAG_TYPE_MAPPING[text]}>
    {text}
  </TagWrapper>
);

export default Tag;
